import { render, staticRenderFns } from "./avatarUpload.vue?vue&type=template&id=58d85492"
import script from "./avatarUpload.vue?vue&type=script&lang=js"
export * from "./avatarUpload.vue?vue&type=script&lang=js"
import style0 from "./avatarUpload.vue?vue&type=style&index=0&id=58d85492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports